import { applicationFlows } from './application';

export default { ...applicationFlows };
